export default httpClient => ({
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/estados', { headers });
        return {
            data: response.data
        }
    },
    getCidades: async ({ estado_id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/cidades/' + estado_id, { headers });
        return {
            data: response
        }
    },
});